export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'dongzuo', name: '动作', icon: 'ri-sword-line' },
  { slug: 'danmei', name: '耽美', icon: 'ri-star-line' },
  { slug: 'juqing', name: '剧情', icon: 'ri-book-open-line' },
];

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  cover: string;
  rating: number;
  description: string;
  status: '连载中' | '已完结';
  chapters: ComicChapter[];
  views: number;
  favorites: number;
  updatedAt: string;
  tags: string[];
}

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '剑与魔法',
    author: '金贤秀',
    category: 'rexue',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20art%2C%20a%20young%20warrior%20holding%20a%20glowing%20sword%20in%20a%20magical%20forest%2C%20dramatic%20lighting%2C%20clean%20modern%20illustration%20style%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20detailed%20character%20design%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-01&orientation=portrait',
    rating: 9.5,
    description: '在一个被魔法笼罩的世界里，年轻的剑士艾伦踏上了寻找传说中的圣剑之旅。沿途他遇到了各种奇特的伙伴，也面临着前所未有的挑战。这不仅是一场冒险，更是一次关于成长与友情的旅程。',
    status: '连载中',
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 10)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1520000,
    favorites: 89000,
    updatedAt: '2026-08-04',
    tags: ['冒险', '战斗', '奇幻', '成长'],
  },
  {
    id: 'comic-2',
    title: '甜蜜陷阱',
    author: '朴智恩',
    category: 'lianai',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%20art%2C%20a%20beautiful%20couple%20standing%20under%20cherry%20blossom%20trees%20at%20sunset%2C%20soft%20pink%20and%20warm%20peach%20tones%2C%20romantic%20atmosphere%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-02&orientation=portrait',
    rating: 9.2,
    description: '冷艳女总裁与温柔男秘书之间发生的甜蜜故事。原本只是工作关系的两人，在日复一日的相处中逐渐产生了超越职场的情感。然而，身份和过去的秘密让这段感情充满了波折。',
    status: '连载中',
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 8)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 980000,
    favorites: 72000,
    updatedAt: '2026-08-03',
    tags: ['恋爱', '职场', '甜宠', '都市'],
  },
  {
    id: 'comic-3',
    title: '暗影猎手',
    author: '李东旭',
    category: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mystery%20thriller%20comic%20cover%20art%2C%20a%20detective%20in%20a%20dark%20alley%20with%20a%20single%20streetlight%2C%20noir%20atmosphere%2C%20deep%20blues%20and%20shadows%2C%20suspenseful%20mood%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-03&orientation=portrait',
    rating: 9.0,
    description: '首尔夜晚的街头，连环失踪案接连发生。前刑警金宇镇被卷入一场超乎想象的阴谋之中。随着调查的深入，他发现这些案件背后隐藏着一个惊人的真相。',
    status: '连载中',
    chapters: Array.from({ length: 28 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 6)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 760000,
    favorites: 54000,
    updatedAt: '2026-08-02',
    tags: ['悬疑', '惊悚', '推理', '都市'],
  },
  {
    id: 'comic-4',
    title: '异世界食堂',
    author: '崔美英',
    category: 'qihuan',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20cooking%20comic%20cover%20art%2C%20a%20cozy%20restaurant%20with%20magical%20creatures%20as%20customers%2C%20warm%20amber%20lighting%2C%20steaming%20dishes%20on%20the%20counter%2C%20whimsical%20atmosphere%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-04&orientation=portrait',
    rating: 9.3,
    description: '一家开在异世界的普通食堂，却因为独特的美食吸引了来自各个种族的客人。精灵、兽人、龙族都成了这里的常客。美食与温情交织，每一道菜都承载着一个故事。',
    status: '已完结',
    chapters: Array.from({ length: 55 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2025-${String((i % 12) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 2100000,
    favorites: 125000,
    updatedAt: '2025-12-20',
    tags: ['奇幻', '美食', '温馨', '治愈'],
  },
  {
    id: 'comic-5',
    title: '校园爆笑王',
    author: '郑宇成',
    category: 'gaoxiao',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20school%20life%20comic%20cover%20art%2C%20a%20group%20of%20funny%20high%20school%20students%20making%20silly%20faces%20in%20a%20classroom%2C%20bright%20vibrant%20colors%2C%20energetic%20composition%2C%20humorous%20expressions%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-05&orientation=portrait',
    rating: 8.8,
    description: '转学生李明浩来到了传说中的"问题班级"，在这里他遇到了一群奇葩同学。每天都有啼笑皆非的事情发生，校园生活从此不再无聊。笑中带泪的青春喜剧！',
    status: '连载中',
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 10)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 670000,
    favorites: 41000,
    updatedAt: '2026-08-05',
    tags: ['搞笑', '校园', '青春', '日常'],
  },
  {
    id: 'comic-6',
    title: '武道至尊',
    author: '朴志训',
    category: 'dongzuo',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20martial%20arts%20action%20comic%20cover%20art%2C%20a%20powerful%20fighter%20in%20dynamic%20combat%20pose%20with%20energy%20aura%2C%20intense%20red%20and%20black%20color%20scheme%2C%20action%20packed%20composition%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-06&orientation=portrait',
    rating: 9.4,
    description: '在武道盛行的世界里，少年刘星从一个被人瞧不起的弱者，通过不懈努力和奇遇，一步步成长为最强的武道至尊。热血战斗、兄弟情义，尽在其中！',
    status: '连载中',
    chapters: Array.from({ length: 65 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 15)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 3200000,
    favorites: 198000,
    updatedAt: '2026-08-04',
    tags: ['动作', '战斗', '热血', '升级'],
  },
  {
    id: 'comic-7',
    title: '星之恋歌',
    author: '金美淑',
    category: 'danmei',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20beautiful%20boys%20love%20comic%20cover%20art%2C%20two%20elegant%20young%20men%20gazing%20at%20stars%20on%20a%20rooftop%20at%20night%2C%20deep%20purple%20and%20silver%20tones%2C%20dreamy%20atmosphere%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-07&orientation=portrait',
    rating: 9.1,
    description: '天才音乐家与普通上班族之间跨越阶层的爱情故事。他们在一次偶然的街头演出中相遇，音乐成为了连接两颗心的桥梁。面对世俗的眼光，他们能否坚守彼此？',
    status: '已完结',
    chapters: Array.from({ length: 40 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2025-${String((i % 12) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1850000,
    favorites: 156000,
    updatedAt: '2025-11-15',
    tags: ['耽美', '音乐', '都市', '精英'],
  },
  {
    id: 'comic-8',
    title: '时间的缝隙',
    author: '尹智浩',
    category: 'juqing',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20drama%20time%20travel%20comic%20cover%20art%2C%20a%20person%20standing%20between%20two%20worlds%20one%20ancient%20one%20modern%2C%20clock%20gears%20floating%20around%2C%20sepia%20and%20teal%20color%20palette%2C%20emotional%20atmosphere%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-08&orientation=portrait',
    rating: 9.6,
    description: '一个普通上班族突然获得了穿越时间的能力，他试图回到过去弥补遗憾，却发现自己每一次改变过去都会引发新的连锁反应。这是一部关于选择、命运和救赎的深刻故事。',
    status: '已完结',
    chapters: Array.from({ length: 60 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2025-${String((i % 12) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 2800000,
    favorites: 210000,
    updatedAt: '2025-10-30',
    tags: ['剧情', '时间', '人生', '深刻'],
  },
  {
    id: 'comic-9',
    title: '热血高校',
    author: '柳承范',
    category: 'rexue',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20school%20fighting%20comic%20cover%20art%2C%20a%20determined%20student%20with%20fist%20raised%20in%20front%20of%20a%20school%20building%2C%20orange%20and%20black%20dynamic%20color%20scheme%2C%20powerful%20energy%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-09&orientation=portrait',
    rating: 9.0,
    description: '以暴制暴的转学生，以一己之力挑战整个学校的不良势力。热血的青春从不缺乏勇气和友情，这是一部让人热血沸腾的校园动作漫画！',
    status: '连载中',
    chapters: Array.from({ length: 50 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 12)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1980000,
    favorites: 134000,
    updatedAt: '2026-08-01',
    tags: ['热血', '校园', '战斗', '友情'],
  },
  {
    id: 'comic-10',
    title: '总裁的契约新娘',
    author: '韩素希',
    category: 'lianai',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20contract%20marriage%20romance%20comic%20cover%20art%2C%20a%20beautiful%20woman%20in%20wedding%20dress%20with%20a%20cold%20handsome%20CEO%2C%20luxury%20setting%2C%20rose%20gold%20and%20cream%20color%20palette%2C%20dramatic%20romantic%20tension%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-10&orientation=portrait',
    rating: 8.9,
    description: '为了拯救家族企业，她不得已与冷血总裁签订了一纸婚约。原以为只是一场交易，却在相处中发现了对方不为人知的温柔一面。契约婚姻能否变成真正的爱情？',
    status: '连载中',
    chapters: Array.from({ length: 33 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 7)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1450000,
    favorites: 98000,
    updatedAt: '2026-08-05',
    tags: ['恋爱', '总裁', '契约', '甜宠'],
  },
  {
    id: 'comic-11',
    title: '龙族传说',
    author: '姜栋元',
    category: 'qihuan',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dragon%20fantasy%20comic%20cover%20art%2C%20a%20dragon%20rider%20soaring%20through%20stormy%20skies%20with%20a%20massive%20dragon%2C%20epic%20scale%2C%20silver%20and%20deep%20blue%20color%20palette%2C%20majestic%20atmosphere%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-11&orientation=portrait',
    rating: 9.7,
    description: '在一个龙与人类共存的世界里，少年龙骑士凯继承了传说中的龙族血脉。他必须在龙族的古老预言和人类世界的存亡之间做出选择。史诗般的奇幻冒险巨作！',
    status: '连载中',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 16)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 4100000,
    favorites: 267000,
    updatedAt: '2026-08-04',
    tags: ['奇幻', '龙', '冒险', '史诗'],
  },
  {
    id: 'comic-12',
    title: '深夜怪谈',
    author: '郑裕美',
    category: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20horror%20mystery%20comic%20cover%20art%2C%20a%20scared%20person%20holding%20a%20flashlight%20in%20a%20dark%20haunted%20corridor%2C%20cold%20blue%20and%20black%20tones%2C%20eerie%20atmosphere%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-12&orientation=portrait',
    rating: 8.7,
    description: '深夜电台主持人收到了一个奇怪的来电，从此他的生活被卷入了一系列超自然事件。每个夜晚都有不同的怪谈，而真相远比想象中更加恐怖。',
    status: '连载中',
    chapters: Array.from({ length: 24 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 5)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 520000,
    favorites: 36000,
    updatedAt: '2026-08-03',
    tags: ['悬疑', '恐怖', '灵异', '都市传说'],
  },
  {
    id: 'comic-13',
    title: '我家大师兄',
    author: '张瑞希',
    category: 'gaoxiao',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20martial%20arts%20comic%20cover%20art%2C%20a%20goofy%20martial%20arts%20disciple%20with%20exaggerated%20expression%20in%20ancient%20Chinese%20setting%2C%20bright%20playful%20colors%2C%20humorous%20tone%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-13&orientation=portrait',
    rating: 8.6,
    description: '修仙门派里最不靠谱的大师兄，却因为各种乌龙事件不断"立功"。师妹们的吐槽、师父的无奈、以及各种奇葩遭遇，让这部漫画笑料百出。',
    status: '连载中',
    chapters: Array.from({ length: 38 }, (_, i) => ({
      id: `ch-13-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 8)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 830000,
    favorites: 52000,
    updatedAt: '2026-08-02',
    tags: ['搞笑', '修仙', '古风', '日常'],
  },
  {
    id: 'comic-14',
    title: '末日军团',
    author: '黄政民',
    category: 'dongzuo',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20post%20apocalyptic%20action%20comic%20cover%20art%2C%20survivors%20fighting%20monsters%20in%20a%20ruined%20city%2C%20dark%20orange%20and%20gray%20color%20scheme%2C%20intense%20survival%20mood%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-14&orientation=portrait',
    rating: 9.2,
    description: '末日降临，丧尸横行。一群幸存者组成了"末日军团"，在废土世界中寻找生的希望。每个人都有自己的故事，而团结是他们唯一的武器。',
    status: '连载中',
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: `ch-14-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 12)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 2650000,
    favorites: 176000,
    updatedAt: '2026-08-05',
    tags: ['动作', '末日', '生存', '丧尸'],
  },
  {
    id: 'comic-15',
    title: '花间辞',
    author: '安昭熙',
    category: 'danmei',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20historical%20romance%20comic%20cover%20art%2C%20two%20handsome%20men%20in%20traditional%20Korean%20hanbok%20in%20a%20flower%20garden%2C%20soft%20pastel%20pink%20and%20green%20palette%2C%20elegant%20romantic%20atmosphere%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-15&orientation=portrait',
    rating: 9.3,
    description: '古代朝鲜王朝背景下，一位才华横溢的画师与贵族公子之间禁忌而美好的感情。花间一壶酒，对影成双人。他们在封建礼教的夹缝中守护着彼此。',
    status: '已完结',
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: `ch-15-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2025-${String((i % 12) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 1680000,
    favorites: 142000,
    updatedAt: '2025-09-18',
    tags: ['耽美', '古风', '历史', '文艺'],
  },
  {
    id: 'comic-16',
    title: '重生之逆天改命',
    author: '权相佑',
    category: 'juqing',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20rebirth%20revenge%20comic%20cover%20art%2C%20a%20determined%20protagonist%20looking%20back%20at%20a%20burning%20past%20life%2C%20dramatic%20contrast%20between%20fire%20and%20shadow%2C%20powerful%20emotional%20expression%2C%20clean%20modern%20illustration%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=manhwa-cover-16&orientation=portrait',
    rating: 9.5,
    description: '被最信任的人背叛至死后，他意外重生回到了十年前。带着前世的记忆，他决心改变一切，让那些曾经伤害过他的人付出代价。一部扣人心弦的复仇与成长故事。',
    status: '连载中',
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: `ch-16-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-0${Math.ceil((i + 1) / 11)}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    views: 3500000,
    favorites: 234000,
    updatedAt: '2026-08-04',
    tags: ['剧情', '重生', '复仇', '商战'],
  },
];